import { IDay } from 'fitbeat.models';
import { Moment } from 'moment';
import moment from 'moment-timezone';
import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { StyleSheet, Text, View } from 'react-native';
import { connect } from 'react-redux';
import { getDatesForNextTwoWeeks } from '../../Planner/plannerActions';
import Sizes from '../../sizes';
import Theme from '../../theme';
import { Dropdown } from '../../ui';
import { defaultScale } from '../../utils/scaling';
import {
  getMinuteForNextInterval,

} from '../utils/BookingUtils';

const dropdownWidth = defaultScale(160);

interface IProps {
  day: IDay;
  isTodayAndIsSoloWorkout: boolean;
  selectedHour: number;
  selectedMinute: number;
  selectedDate: number;
  hours: IDropdownValue[];
  minutes: IDropdownValue[];
  days: IDropdownValue[];
  mode: 'date' | 'time' | 'datetime' | undefined;
  minutesInterval?: number[];
  workoutDateTimeSelected(date: number): void;
}

interface IDropdownValue {
  value: number;
  display: string;
}

const showDatePicker = (mode: 'date' | 'time' | 'datetime' | undefined) => mode === 'date' || mode === 'datetime';

class HomeTimeSlotSelectionComponent extends Component<IProps> {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  public componentDidMount() {
    const mo = getMinuteForNextInterval(new Date(this.props.day.date));
    this.props.workoutDateTimeSelected(mo.valueOf());
  }

  public hourSelected = (hour) => {
    const mo = moment(this.props.day.date);
    mo.hour(hour);
    this.props.workoutDateTimeSelected(mo.valueOf());
  };

  public minuteSelected = (minute) => {
    const mo = moment(this.props.day.date);
    mo.minute(minute);
    this.props.workoutDateTimeSelected(mo.valueOf());
  };

  public dateSelected = (date) => {
    const mo = moment(date);
    mo.minute(this.props.selectedMinute);
    mo.hour(this.props.selectedHour);
    mo.second(0);
    mo.millisecond(0);
    this.props.workoutDateTimeSelected(mo.valueOf());
  };

  public render() {
    const { isTodayAndIsSoloWorkout } = this.props;
    const menuPlacement = isTodayAndIsSoloWorkout ? 'top' : 'bottom';

    return (
      <View>
        <View style={styles.datetimeContainer}>
          {showDatePicker(this.props.mode) && (
          <View style={styles.dropDownContainer}>
            <Dropdown
              webAbsolute
              useTransparentTheme
              valueKey='value'
              displayKey='display'
              placeholder='Hour'
              defaultValue={this.props.selectedDate}
              defaultIndex={-1}
              options={this.props.days}
              isSearchable={false}
              rowWidth={dropdownWidth}
              optionContainer={{ maxHeight: defaultScale(170) }}
              controlTextStyle={styles.controlTextStyle}
              input={{ onChange: this.dateSelected }}
              showLabel={false}
              menuPlacement={menuPlacement}
              mainDropdownContainerStyle={{ backgroundColor: Theme.GREY_LIGHT }}
              height={defaultScale(Sizes.ButtonMedium)}
            />
          </View>
          )}
          {this.props.mode !== 'date' && (
          <View style={styles.timeContainer}>
            <View style={styles.dropDownContainer}>
              <Dropdown
                webAbsolute
                useTransparentTheme
                valueKey='value'
                displayKey='display'
                placeholder='Hour'
                defaultValue={this.props.selectedHour}
                defaultIndex={-1}
                options={this.props.hours}
                component={Dropdown}
                isSearchable={false}
                rowWidth={dropdownWidth}
                optionContainer={{ maxHeight: defaultScale(170) }}
                controlTextStyle={styles.controlTextStyle}
                input={{ onChange: this.hourSelected }}
                showLabel={false}
                menuPlacement={menuPlacement}
                mainDropdownContainerStyle={{ backgroundColor: Theme.GREY_LIGHT }}
                height={defaultScale(Sizes.ButtonMedium)}
              />
            </View>
            <Text style={styles.timeSeparator}>:</Text>
            <View style={styles.dropDownContainer}>
              <Dropdown
                webAbsolute
                useTransparentTheme
                valueKey='value'
                displayKey='display'
                options={this.props.minutes}
                isSearchable={false}
                placeholder='Minute'
                defaultValue={this.props.selectedMinute}
                defaultIndex={-1}
                controlTextStyle={styles.controlTextStyle}
                optionContainer={{ maxHeight: defaultScale(170) }}
                rowWidth={dropdownWidth}
                input={{ onChange: this.minuteSelected }}
                showLabel={false}
                height={defaultScale(Sizes.ButtonMedium)}
                menuPlacement={menuPlacement}
              />
            </View>
          </View>
          )}
        </View>
      </View>
    );
  }
}
const styles = StyleSheet.create({
  dateDropdownStyle: {
    zIndex: 1000,
    paddingHorizontal: defaultScale(10),
    width: defaultScale(320),
  },
  datetimeContainer: {
    zIndex: 1,
    width: '100%',
    flexDirection: 'row',
    paddingVertical: defaultScale(10),
    justifyContent: 'center',
    flexWrap: 'wrap',
    gap: defaultScale(10),
  },
  timeContainer: {
    display: 'flex',
    flexDirection: 'row',
  },
  dropDownContainer: {
    zIndex: 1,
    width: dropdownWidth,
    backgroundColor: Theme.GREY_LIGHT,
  },
  controlTextStyle: {
    ...Theme.textStyle.bodyCopyMed,
    color: Theme.CHARCOAL,
  },
  dropdownLabel: {
    zIndex: 1,
    color: Theme.CHARCOAL,
    fontSize: 14,
    fontFamily: Theme.Custom200,
  },
  timeSeparator: {
    ...Theme.textStyle.heading,
    alignSelf: 'center',
  },
});

const mapStateToProps = (state, ownProps): Partial<IProps> => {
  const { date } = ownProps.day;
  const isToday = moment(date).isSame(moment(), 'day');
  return {
    selectedDate: moment(date).startOf('day').valueOf(),
    selectedHour: moment(date).hour(),
    selectedMinute: moment(date).minute(),
    days: getDatesForNextTwoWeeks().map((mo: Moment) => ({
      value: moment(mo).startOf('day').valueOf(),
      display: mo.format('DD MMM'),
    })),
    minutes: getAvailableMinutesBasedOnSelection(isToday, date, ownProps.minutesInterval),
    hours: getAvailableHoursBasedOnSelection(isToday),
  };
};

export const HomeTimeSlotSelection = connect(mapStateToProps)(
  translate(['bookings'], { wait: true })(HomeTimeSlotSelectionComponent),
);

function getAvailableHoursBasedOnSelection(isToday: any): IDropdownValue[] | undefined {
  return [...Array(24).keys()]
    .filter((hour: number) => (isToday ? hour >= moment().hour() : true))
    .map((value) => ({
      value,
      display: `${value < 10 ? '0' : ''}${value}`,
    }));
}

function getAvailableMinutesBasedOnSelection(
  isToday: any,
  date: any,
  minutesInterval?: number[],
): IDropdownValue[] | undefined {
  const intervals = minutesInterval ?? [0, 15, 30, 45];

  return intervals
    .filter((minute: number) => (isToday && moment(date).hour() === moment().hour()
      ? minute > moment().minute()
      : true))
    .map((value) => ({
      value,
      display: value === 0 ? '00' : value.toString(),
    }));
}
